export interface Invite {
  token?: string;
  saveId?: string;
  saveName: string;
  saveDescription?: string | null;
  role: string;
  expiresAt?: string;
}

export const adaptInvite = (data: any): Invite => ({
  token: data.token,
  saveId: data.save_id ?? data.saveId ?? data.save?.id,
  saveName: data.save_name ?? data.saveName ?? data.save?.name ?? '',
  saveDescription: data.save_description ?? data.saveDescription ?? data.save?.description ?? null,
  role:
    data.role?.name ??
    data.role?.code ??
    data.role_name ??
    data.roleName ??
    data.roleCode ??
    data.role_code ??
    data.role ??
    '',
  expiresAt: data.expiresAt ?? data.expires_at,
});
